export default "__VITE_ASSET__DFuGONhv__"